export default __webpack_public_path__ + "static/media/video6.999def4c.mp4";